import { mapKeys } from 'lodash-es'

export const DEFINE = 'DEFINE'
export const QC = 'QC'
export const QQA = 'QQA'

export const TASK_VIEW_TYPES = mapKeys(
  [
    { name: 'Define', value: DEFINE },
    { name: 'QC', value: QC },
    { name: 'QQA', value: QQA },
  ],
  'value',
)
